var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',{attrs:{"name":_vm.name,"label":_vm.label,"type":"imageswitch","options":_vm.cliparts.map(function (clipart) { return ({
      value: Object.assign({}, clipart.file, {categoryID: clipart.category.id}),
      image: clipart.thumbnail.key,
      color: clipart.color,
      title: clipart.title
    }); }),"validation":"required","showTitle":true}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16d14a91","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ClipartsByCategory.vue
// module id = 215
// module chunks = 0